export const homeObjOne4 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: 'Vi hjälper er att förverkliga ert drömbröllop',
    description: 'Bröllopsdagen är en av livets allra största och mest betydelsefulla dagar – en dag fylld av kärlek, glädje och minnen som varar för evigt. Vi vet hur viktigt det är att varje detalj blir precis som ni har drömt om. Med lång erfarenhet av att planera och genomföra bröllop finns vi med er hela vägen. Från de första idéerna och den inledande planeringen till den stora dagen, hjälper vi er att skapa ett bröllop som känns personligt, genomtänkt och helt unikt för just er.',
    imgStart: false,
    img: require('../../AssetsForWedding/cake.jpg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}